import script from "./detailAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./detailAuth.vue?vue&type=script&setup=true&lang=js"

import "./detailAuth.vue?vue&type=style&index=0&id=78ded373&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ded373"]])

export default __exports__